import React, { useState } from 'react';
import icons from '../../icons';
import Switch from '../Switch/Switch';
import style from './Cookies.module.css';


const Cookies = () => {
    const [preferenceCookies, setPreferenceCookies] = useState(JSON.parse(localStorage.getItem("cookies") || "{}")?.preferenceCookies);
    const [statisticCookies, setStatisticCookies] = useState(JSON.parse(localStorage.getItem("cookies") || "{}")?.statisticCookies);
    const [marketingCookies, setMarketingCookies] = useState(JSON.parse(localStorage.getItem("cookies") || "{}")?.marketingCookies);

    return <main className={ style.main }>
        <div style={{ display: "flex", marginLeft: "1rem" }}>
            <img src={ icons.logo_icon }></img>
            <h4 style={{ marginLeft: ".5rem" }}>SchoolDiary</h4>
        </div>
        <div style={{ display: "flex", marginLeft: "1rem", marginTop: "-.5rem" }}>
            <img src={ icons.arrow_left_icon }></img>
            <a href="/" style={{ color: "white", marginLeft: "0", fontWeight: "bold" }}>Torna alla home</a>
        </div>
        <h1 className={ style.title }>Cookies e tecnologie simili</h1>
        <hr style={{ margin: "1.5rem 2rem", borderTop: "1px solid #bbb", borderBottom: "none" }}></hr>
        <h3 className={ style.description }>I cookies e tecnologie simili come il local storage permettono di fornire un'esperienza migliore, più veloce e sicura su SchoolDiary. In particolare, SchoolDiary utilizza queste tecnologie per:</h3>
        <ul style={{ fontWeight: "bold" }}>
            <li>Mantenere l'accesso come utente</li>
            <li>Raccogliere dati aggregati e anonimi come sistema operativo e browser utilizzati</li>
            <li>Personalizzare gli annunci forniti terzi</li>
        </ul>
        <hr style={{ margin: "1.5rem 2rem", borderTop: "1px solid #bbb", borderBottom: "none" }}></hr>
        <h1 className={ style.title }>Cosa sono i cookies e il local storage?</h1>
        <h3 className={ style.description }>
            I cookie sono piccoli file di testo che possono essere utilizzati dai siti web per rendere più efficiente l'esperienza per l'utente.
            La legge afferma che possiamo memorizzare i cookie sul tuo dispositivo se sono strettamente necessari per il funzionamento di questo sito. Per tutti gli altri tipi di cookie abbiamo bisogno del tuo consenso.
            Questo sito utilizza diversi tipi di cookie. Alcuni cookie sono collocati da servizi di terzi che compaiono sulle nostre pagine.
            In qualsiasi momento è possibile modificare o revocare il proprio consenso
        </h3>
        <hr style={{ margin: "1.5rem 2rem", borderTop: "1px solid #bbb", borderBottom: "none" }}></hr>
        <div style={{ display: "flex" }}>
            <h2 className={ style.categoryHeader }>Cookie necessari</h2>
            <Switch disabled={ true } active={ true } width="12.5vw" height="3vh" />
        </div>
        <h3 className={ style.description }>
            I cookie necessari contribuiscono a rendere fruibile il sito web abilitandone funzionalità di base quali la navigazione sulle pagine e l'accesso alle aree protette del sito. Il sito web non è in grado di funzionare correttamente senza questi cookie.
        </h3>
        <hr style={{ margin: "1.5rem 2rem", borderTop: "1px solid #bbb", borderBottom: "none" }}></hr>
        <div style={{ display: "flex" }}>
            <h2 className={ style.categoryHeader }>Cookie di preferenza</h2>
            <Switch active={ preferenceCookies } onChange={ () => {
                localStorage.setItem("cookies", JSON.stringify({ preferenceCookies: !preferenceCookies, statisticCookies, marketingCookies }));
                setPreferenceCookies(oldPreferenceCookies => !oldPreferenceCookies);
            } } width="12.5vw" height="3vh" />
        </div>
        <h3 className={ style.description }>
            I cookie di preferenza consentono al sito web di memorizzare informazioni che ne influenzano il comportamento o l'aspetto.
        </h3>
        <hr style={{ margin: "1.5rem 2rem", borderTop: "1px solid #bbb", borderBottom: "none" }}></hr>
        <div style={{ display: "flex" }}>
            <h2 className={ style.categoryHeader }>Cookie statistici</h2>
            <Switch active={ statisticCookies } onChange={ () => {
                localStorage.setItem("cookies", JSON.stringify({ preferenceCookies, statisticCookies: !statisticCookies, marketingCookies }));
                setStatisticCookies(oldStatisticCookies => !oldStatisticCookies);
            } }  width="12.5vw" height="3vh" />
        </div>
        <h3 className={ style.description }>
            I cookie statistici aiutano il proprietario del sito web a capire come i visitatori interagiscono con i siti raccogliendo e trasmettendo informazioni in forma anonima.
        </h3>
        <hr style={{ margin: "1.5rem 2rem", borderTop: "1px solid #bbb", borderBottom: "none" }}></hr>
        <div style={{ display: "flex" }}>
            <h2 className={ style.categoryHeader }>Cookie di marketing</h2>
            <Switch active={ marketingCookies } onChange={ () => {
                localStorage.setItem("cookies", JSON.stringify({ preferenceCookies, statisticCookies, marketingCookies: !marketingCookies }));
                setMarketingCookies(oldMarketingCookies => !oldMarketingCookies);
            } }  width="12.5vw" height="3vh" />
        </div>
        <h3 className={ style.description } style={{ marginBottom: "2rem" }}>
            I cookie di marketing vengono utilizzati per tracciare i visitatori sui siti web. La finalità è quella di presentare annunci pubblicitari che siano rilevanti e coinvolgenti per il singolo utente e quindi di maggior valore per editori e inserzionisti di terze parti.
        </h3>
    </main>
};

export default Cookies;